import FluxUtils from 'flux/utils';

import asFunctional from 'sharedreact/components/asFunctional';
import SettingsStore from 'sharedreact/stores/SettingsStore';

import AuthenticationLauncherActions from 'workspaces/launcher/actions/AuthenticationLauncherActions';
import AuthenticationLauncherPage from 'workspaces/launcher/components/authentication/AuthenticationLauncherPage';

type State = ConstructorParameters<typeof AuthenticationLauncherPage>[0];

function getStores () {
  return [
    SettingsStore
  ];
}

function calculateState (prevState?: State): State {
  return {
    language: SettingsStore.getLanguage(),
    postLogin: AuthenticationLauncherActions.doPostLoginInit,
    postLogout: AuthenticationLauncherActions.doPostLogoutCleanup
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(AuthenticationLauncherPage),
  getStores,
  calculateState
);
